import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MgsFieldDefaultComponent } from './mgs-field-default.component';
import { NgStyle } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { MatError, MatFormField, MatHint } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'mng-mgs-field-string-component',
  imports: [NgStyle, MatFormField, MatHint, MatError, ReactiveFormsModule, CdkTextareaAutosize, MatInput],
  template: `
    <div style="width: 100%; padding-top: 10px;" [ngStyle]="style">
      <mat-form-field
        style="width: 100%; color: black;"
        [appearance]="appearance"
        color="accent"
        [attr.id]="defId"
        [floatLabel]="floatLabel"
        subscriptSizing="dynamic"
      >
        <textarea
          #inputTextarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="3"
          [maxLength]="1000"
          [formControl]="formControl"
          [required]="uiAttribut.attribut.mandatory"
          style="width: 100%; font-size: small;"
          (keydown)="onKeydown($event)"
        ></textarea>

        <mat-hint align="end">
          <span> {{ inputTextarea.value ? inputTextarea.value.length : '0' }} / {{ 1000 }} </span>
        </mat-hint>

        @if (formControl.errors) {
          <mat-error>{{ formControl.errors[0] }}</mat-error>
        }
      </mat-form-field>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MgsFieldStringComponent extends MgsFieldDefaultComponent {
  constructor() {
    super();
  }
}
